import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchProductSummaryProps = {
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
  am?: Array<string>;
};
export type FetchProductSummary = (filters: FetchProductSummaryProps) => void;

const fetchProductSummary = ({
  clusters = [],
  partners = [],
  origami,
  am = [],
}: FetchProductSummaryProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
    account_manager: am.length ? "'" + am.join("','") + "'" : null,
  };
  await fetchReport("product_summary", dispatch, params);
};

export default fetchProductSummary;
